"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = __importDefault(require("./"));
const buy_1 = require("./restful/buy");
const commerce_1 = require("./restful/commerce");
const developer_1 = require("./restful/developer");
const postOrder_1 = require("./restful/postOrder");
const sell_1 = require("./restful/sell");
const traditional_1 = __importDefault(require("./traditional"));
/**
 * Factory class to create RESTFul API or Traditional API.
 */
class ApiFactory extends _1.default {
    constructor() {
        super(...arguments);
        this._restful = {};
    }
    createBuyApi() {
        return {
            browse: this.createRestfulApi(buy_1.Browse),
            feed: this.createRestfulApi(buy_1.Feed),
            marketing: this.createRestfulApi(buy_1.Marketing),
            offer: this.createRestfulApi(buy_1.Offer),
            order: this.createRestfulApi(buy_1.Order),
            deal: this.createRestfulApi(buy_1.Deal),
            marketplaceInsights: this.createRestfulApi(buy_1.MarketplaceInsights),
        };
    }
    createCommerceApi() {
        return {
            catalog: this.createRestfulApi(commerce_1.Catalog),
            identity: this.createRestfulApi(commerce_1.Identity),
            taxonomy: this.createRestfulApi(commerce_1.Taxonomy),
            translation: this.createRestfulApi(commerce_1.Translation),
            charity: this.createRestfulApi(commerce_1.Charity),
            notification: this.createRestfulApi(commerce_1.Notification),
        };
    }
    createDeveloperApi() {
        return {
            analytics: this.createRestfulApi(developer_1.Analytics),
        };
    }
    createPostOrderApi() {
        return {
            cancellation: this.createRestfulApi(postOrder_1.Cancellation),
            case: this.createRestfulApi(postOrder_1.Case),
            inquiry: this.createRestfulApi(postOrder_1.Inquiry),
            return: this.createRestfulApi(postOrder_1.Return),
        };
    }
    createSellApi() {
        return {
            account: this.createRestfulApi(sell_1.Account),
            analytics: this.createRestfulApi(sell_1.Analytics),
            compliance: this.createRestfulApi(sell_1.Compliance),
            fulfillment: this.createRestfulApi(sell_1.Fulfillment),
            inventory: this.createRestfulApi(sell_1.Inventory),
            marketing: this.createRestfulApi(sell_1.Marketing),
            metadata: this.createRestfulApi(sell_1.Metadata),
            recommendation: this.createRestfulApi(sell_1.Recommendation),
            finances: this.createRestfulApi(sell_1.Finances),
            feed: this.createRestfulApi(sell_1.Feed),
            logistics: this.createRestfulApi(sell_1.Logistics),
            negotiation: this.createRestfulApi(sell_1.Negotiation),
            listing: this.createRestfulApi(sell_1.Listing),
        };
    }
    get traditional() {
        if (this._traditional) {
            return this._traditional;
        }
        return (this._traditional = new traditional_1.default(this.config, this.req, this.auth));
    }
    createTradingApi() {
        return this.traditional.createTradingApi();
    }
    createShoppingApi() {
        return this.traditional.createShoppingApi();
    }
    createFindingApi() {
        return this.traditional.createFindingApi();
    }
    createClientAlertsApi() {
        return this.traditional.createClientAlertsApi();
    }
    createMerchandisingApi() {
        return this.traditional.createMerchandisingApi();
    }
    // tslint:disable-next-line:variable-name
    createRestfulApi(RestfulApiClass) {
        const id = RestfulApiClass.id;
        return (this._restful[id] || (this._restful[id] = new RestfulApiClass(this.config, this.req, this.auth)));
    }
}
exports.default = ApiFactory;
//# sourceMappingURL=apiFactory.js.map